import { Locales } from '@ratehub/base-ui';


export default function getApplicationUrlWithAgent(locale, agentID, canApplyWithAgent = true) {
    const applicationUrl = locale === Locales.FRENCH
        ? `/mortgages/landing?lang=fr&agent=${agentID}`
        : `/mortgages/landing?agent=${agentID}`;

    return canApplyWithAgent
        ? applicationUrl
        : null;
}
